import styled from "styled-components";
import { Column } from "uikit";

const Root = styled(Column)`
	min-width: 0;
`;

export default Root;
